var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 492,
    height: 92,
    viewBox: "0 0 539 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.9 50.1001H375.641C385.735 50.1001 392.742 55.3691 392.742 64.236V64.3564C392.742 74.089 384.462 79.0795 374.813 79.0795H362.34V96.3015H358.9V50.1001ZM374.933 75.8729C383.484 75.8729 389.302 71.3566 389.302 64.5822V64.4693C389.302 57.1003 383.717 53.2991 375.407 53.2991H362.34V75.8804L374.933 75.8729Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414 49.7461H417.327L438.824 96.3012H434.993L429.174 83.3547H402.009L396.07 96.3012H392.51L414 49.7461ZM427.782 80.2685L415.663 53.5473L403.432 80.2685H427.782Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M446.779 50.1001H466.139C471.837 50.1001 476.346 51.884 479.078 54.6164C480.215 55.7555 481.115 57.108 481.727 58.596C482.339 60.0841 482.652 61.6785 482.646 63.2876V63.4381C482.646 71.1534 476.94 75.5492 469.097 76.6181L484.302 96.3316H480.027L465.296 77.2127H450.242V96.3316H446.794L446.779 50.1001ZM465.778 74.089C473.501 74.089 479.199 70.1749 479.199 63.551V63.4381C479.199 57.2584 474.329 53.3367 465.898 53.3367H450.227V74.1191L465.778 74.089Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492.619 50.1069H496.059V80.3885L525.392 50.1069H530.149L509.954 70.528L530.977 96.3008H526.461L507.583 72.9065L496.059 84.5435V96.3008H492.619V50.1069Z",
    fill: "#FCFCFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M538.286 101.246H166.56V104.099H538.286V101.246Z",
    fill: "#FCFCFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.567 49.9272H177.007V80.3292L206.34 49.9272H211.09L190.902 70.3558L211.926 96.1211H207.409L188.411 72.7269L177.007 84.3638V96.1211H173.567V49.9272Z",
    fill: "#FCFCFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228.079 49.9272H224.632V96.1211H228.079V49.9272Z",
    fill: "#FCFCFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M245.646 49.9272H248.973L280.798 90.0693V49.9272H284.005V96.1211H281.513L248.973 55.1511V96.1211H245.646V49.9272Z",
    fill: "#FCFCFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M299.211 73.2228V73.1024C299.211 60.517 308.469 49.2339 322.485 49.2339C336.38 49.2339 345.525 60.2762 345.525 72.869V73.1024C345.525 85.6952 336.259 96.8579 322.364 96.8579C308.469 96.8579 299.211 85.7931 299.211 73.2228ZM342.078 73.2228V73.1024C342.078 61.7063 333.798 52.32 322.364 52.32C310.931 52.32 302.794 61.4655 302.794 72.869V73.1024C302.794 84.5059 311.074 93.7718 322.507 93.7718C333.941 93.7718 342.078 84.6264 342.078 73.2228Z",
    fill: "#FCFCFD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M538.286 41.6167H166.56V44.4695H538.286V41.6167Z",
    fill: "#FCFCFD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.062,
    cy: 68.9806,
    r: 22.123,
    fill: "#E6652C",
    stroke: "#FCFCFD",
    strokeWidth: 2.25813
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.3786,
    cy: 59.8743,
    r: 31.2301,
    fill: "#FDB73A",
    stroke: "#FCFCFD",
    strokeWidth: 2.25813
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.8685,
    cy: 46.1166,
    r: 44.9875,
    fill: "#73A050",
    stroke: "#FCFCFD",
    strokeWidth: 2.25813
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8701 64.7173V102.308M98.2184 74.7417V102.308M134.453 86.8807V102.308",
    stroke: "#FCFCFD",
    strokeWidth: 2.25813
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo_light.b58e756bcaf9d8c10f0863ae62874c40.svg";
export { ForwardRef as ReactComponent };